<template>

    <templatesite>

        <template v-slot:appheader> <appheader></appheader> </template>
        <template v-slot:appsidebar> <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <div class="content" style="margin-top: 0">
                <div class="main-content">

                    <!-- Start::page-header -->
                    <div class="ds-page-head">
                        <div>
                            <h1 class="ds-page-head__title">
                                <i class="ri-qr-code-line"></i> Scan &amp; Go
                            </h1>
                            <p class="ds-page-head__sub">QR d'accès du magasin</p>
                        </div>
                    </div>
                    <!-- End::page-header -->

                    <div class="grid grid-cols-12 gap-x-6">

                        <!-- Carte QR du magasin -->
                        <div class="xl:col-span-5 col-span-12">
                            <div class="cf-card">
                                <div class="sg-card-head">
                                    <h3 class="cf-card__title">{{ titreSupport }}</h3>
                                    <span v-if="qrCodeDataUrl" class="cf-st cf-st--ok">
                                        <i class="ri-checkbox-circle-line"></i> actif
                                    </span>
                                </div>
                                <div>

                                    <div class="text-center">
                                        <div style="width:220px;height:220px;background:#fff;border:1px solid var(--cf-border);border-radius:var(--cf-radius);display:flex;align-items:center;justify-content:center;margin:0 auto;padding:8px;">
                                            <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="QR Scan & Go du magasin" style="width:100%;height:100%;object-fit:contain;" />
                                            <span v-else class="sg-muted text-[0.8rem]">Génération…</span>
                                        </div>
                                    </div>

                                    <div class="mt-4">
                                        <label class="fa2-label"><span class="fa2-req">*</span> Magasin / Dépôt / Entrepôt</label>
                                        <div class="relative">
                                            <select v-model="selectedMagasin" @change="persistReglages" class="fa2-inp fa2-select">
                                                <option :value="null" disabled>Sélectionner un entrepôt</option>
                                                <option v-for="(magasin, index) in returnGetAllmagasin" :key="index" :value="magasin">
                                                    {{ magasin.name }}
                                                </option>
                                            </select>
                                            <i class="ri-arrow-down-s-line fa2-select-arrow"></i>
                                        </div>
                                    </div>

                                    <!-- Type de support : supermarché (self-scan) ou restaurant (menu) -->
                                    <div class="mt-3">
                                        <label class="fa2-label">Type de support</label>
                                        <div class="flex items-center gap-2">
                                            <button type="button" @click="setMode(false)"
                                                    :class="!modeRestaurant ? 'ti-btn ti-btn-primary-full' : 'ds-btn-ghost'">
                                                <i class="ri-shopping-basket-2-line align-middle me-1"></i>Supermarché
                                            </button>
                                            <button type="button" @click="setMode(true)"
                                                    :class="modeRestaurant ? 'ti-btn ti-btn-primary-full' : 'ds-btn-ghost'">
                                                <i class="ri-restaurant-line align-middle me-1"></i>Restaurant
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Numéro de table (restaurant uniquement) -->
                                    <div v-if="modeRestaurant" class="mt-3">
                                        <label class="fa2-label">
                                            Numéro de table
                                            <span class="sg-muted" style="text-transform:none;">(vide = affiche murale pour les serveurs)</span>
                                        </label>
                                        <input v-model.lazy="numeroTable" @change="persistReglages" type="text"
                                               class="fa2-inp" placeholder="Ex : 12">
                                    </div>

                                    <div style="display: block!important;" class="mt-3">
                                        <label class="fa2-label">Lien encodé dans le QR</label>
                                        <div class="text-[0.72rem] break-all sg-code">{{ qrValue }}</div>
                                        <div class="mt-1 text-[0.72rem]" :class="shortUrl ? 'cf-ok' : 'cf-attente'">
                                            <i :class="shortUrl ? 'ri-checkbox-circle-line' : 'ri-information-line'" class="align-middle me-1"></i>
                                            <span v-if="shortUrl">Lien court actif - QR optimisé pour un scan rapide.</span>
                                            <span v-else>QR en URL longue (plus dense). Cliquez pour générer un lien court.</span>
                                        </div>
                                    </div>

                                    <!-- Génère l'URL courte encodée dans le QR (raccourcisseur). -->
                                    <div class="mt-3">
                                        <button @click="genererLienCourt" type="button"
                                                :disabled="courtEnCours || !selectedMagasin"
                                                class="ti-btn ti-btn-primary-full !text-[0.85rem] w-full">
                                            <i class="align-middle me-1"
                                               :class="courtEnCours ? 'ri-loader-4-line animate-spin' : 'ri-link'"></i>
                                            {{ courtEnCours ? 'Génération…' : 'Générer le lien court (QR)' }}
                                        </button>
                                    </div>

                                    <div class="btn-list mt-3">
                                        <button @click="telechargerQr" type="button"
                                                class="ds-btn-ghost">
                                            <i class="ri-download-2-line"></i>Télécharger le QR
                                        </button>
                                    </div>

                             

                                </div>
                            </div>
                        </div>

                        <!-- Aperçu de l'affiche -->
                        <div class="xl:col-span-7 col-span-12">
                            <div class="cf-card">
                                <div class="sg-card-head">
                                    <h3 class="cf-card__title"><i class="ri-image-line"></i> Affiche à imprimer</h3>
                                    <div class="cf-tool-grp">
                                        <button @click="imprimerAffiche" type="button"
                                                :disabled="!posterDataUrl"
                                                class="ti-btn ti-btn-primary-full !text-[0.8rem]">
                                            <i class="ri-printer-line align-middle me-1"></i>Imprimer l'affiche
                                        </button>
                                        <button @click="telechargerAffiche" type="button"
                                                :disabled="!posterDataUrl"
                                                class="ds-btn-ghost">
                                            <i class="ri-download-2-line"></i>Télécharger
                                        </button>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <img v-if="posterDataUrl" :src="posterDataUrl" alt="Affiche Scan & Go"
                                         style="max-width:100%;max-height:640px;border:1px solid var(--cf-border);border-radius:var(--cf-radius-sm);" />
                                    <div v-else class="sg-muted text-[0.85rem] py-10">
                                        <i class="ri-loader-4-line animate-spin align-middle me-1"></i>Préparation de l'affiche…
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </template>

    </templatesite>

</template>

<script>
    /* eslint-disable */
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import { randomString } from "@/allfunction";
    import QRCode from "qrcode";
    const axios = require('axios');
    import * as JwtService from "@/common/jwt.service";

    export default {
        name: "scanandgoindex",
        components: { templatesite, appheader, appsidebar },
        data: () => ({
            selectedMagasin: null,
            // Mode restaurant (menu) vs supermarché (self-scan) + numéro de table
            modeRestaurant: false,
            numeroTable: "",
            // Segments de l'URL encodée dans le QR (générés une seule fois au montage)
            keyauthorisation: "",
            rand1: "",
            rand2: "",
            // Lien court obtenu du backend (raccourcisseur). Vide = QR en URL longue.
            // Généré À LA DEMANDE via le bouton (pas automatiquement) : l'admin règle
            // magasin/mode/table, puis clique « Générer le lien court ».
            shortUrl: "",
            courtEnCours: false,
            qrCodeDataUrl: "",
            posterDataUrl: "",
            posterSrc: "/assets/affiche-scanandgo.png",
            posterSrcRestaurant: "/assets/affiche-menu.png",
            logoSrc: "/assets/logopaie.png",
            qrColor: "#111111",
            contact: "0143927013",
            // Position du carré blanc réservé dans l'affiche SUPERMARCHÉ (fractions de l'image)
            poster: {
                cx: 0.500,     // centre X
                cy: 0.487,     // centre Y
                size: 0.360,   // largeur de la carte QR (fraction de la largeur)
                pad: 0.070,    // marge blanche interne (fraction de la carte)
                radius: 26,    // arrondi de la carte
            },
            // Position du carré blanc réservé dans l'affiche RESTAURANT (affiche-menu.png 1696×2528)
            posterResto: {
                cx: 0.500,     // centré horizontalement
                cy: 0.683,     // carré QR descendu (bas-milieu)
                size: 0.250,   // ~25 % de la largeur
                pad: 0.060,
                radius: 20,
            },
            // Position/taille du badge « TABLE N » sur l'affiche restaurant (fractions de l'image)
            // Placé au-dessus des têtes, sur la zone claire du plafond de la photo
            posterTable: {
                cx: 0.500,
                cy: 0.120,
                fs: 0.036,
            },
        }),
        computed: {
            appsociete() {
                return this.$store.state.appsociete;
            },
            societeName() {
                return this.$store.state.etatraisonsocial || "";
            },
            ifu() {
                return this.$store.state.etatifu || "";
            },
            // Nom affiché (affiche/footer) = magasin sélectionné, sinon raison sociale
            nomMagasin() {
                return this.selectedMagasin ? this.selectedMagasin.name : this.societeName;
            },
            // Liste des magasins / dépôts / entrepôts (même source que form.vue)
            returnGetAllmagasin() {
                if (!this.$store.state.annexeuser || this.$store.state.annexeuser.length === 0) {
                    return [];
                }
                return this.$store.state.annexeuser;
            },
            titreSupport() {
                return this.modeRestaurant ? "QR restaurant (menu)" : "QR du magasin";
            },
            pwaUrl() {
                let base = process.env.VUE_APP_URL || "";
                if (base && !base.endsWith("/")) base += "/";
                const soc = encodeURIComponent(this.appsociete || "");
                const mag = encodeURIComponent(this.selectedMagasin ? this.selectedMagasin.pid : "");
                const key = encodeURIComponent(this.keyauthorisation || "");
                if (this.modeRestaurant) {
                    // Restaurant : menu/{soc}/{mag}/{key}/{table}/{random}
                    // table = "0" → affiche murale (aucune table précise), sinon numéro de table
                    const table = encodeURIComponent(this.numeroTable ? this.numeroTable : "0");
                    // restaurant : '/menu/:mag/:key/:table?'
                    //return `${base}menu/${soc}/${mag}/${key}/${table}/${this.rand1}`;
                    return `${base}menu/${mag}/${key}/${table}`;
                }
                // Supermarché : '/panier/:mag/:key'
                //return `${base}panier/${soc}/${mag}/${key}/${this.rand1}`;
                return `${base}panier/${mag}/${key}`;
            },

            /* Chemin interne (relatif) déposé comme CIBLE du lien court. Doit refléter
               pwaUrl à l'identique, sans l'origine - c'est ce que le backend valide
               (préfixe /panier/ ou /menu/) et ce vers quoi la page /s/:code redirige. */
            ciblePath() {
                const mag = encodeURIComponent(this.selectedMagasin ? this.selectedMagasin.pid : "");
                const key = encodeURIComponent(this.keyauthorisation || "");
                if (this.modeRestaurant) {
                    const table = encodeURIComponent(this.numeroTable ? this.numeroTable : "0");
                    return `/menu/${mag}/${key}/${table}`;
                }
                return `/panier/${mag}/${key}`;
            },

            /* Clé d'idempotence du lien court : un support = un code permanent réutilisé
               (poster réimprimé → même URL courte). Panier : par magasin. Menu : par
               magasin + table (0 = mural). */
            scopeCourt() {
                const mag = this.selectedMagasin ? this.selectedMagasin.pid : "";
                return this.modeRestaurant ? `${mag}|${this.numeroTable || "0"}` : String(mag);
            },

            // Ce qui est réellement encodé dans le QR : le lien court si obtenu, sinon
            // l'URL longue (repli). Basculer de l'un à l'autre relance rebuildAll.
            qrValue() {
                return this.shortUrl || this.pwaUrl;
            },
        },
        watch: {
            pwaUrl() {
                // La cible a changé (magasin, mode, table) → le lien court précédent
                // ne correspond plus. On l'oublie : le QR repasse en URL longue tant
                // que l'admin n'a pas re-cliqué « Générer le lien court ».
                this.shortUrl = "";
                this.rebuildAll();
            },
            // La liste peut arriver après le montage (chargée au login) : sélection par défaut
            returnGetAllmagasin(list) {
                if (list && list.length && !this.selectedMagasin) {
                    this.chargerReglages();
                }
            },
        },
        methods: {

            storageKey(suffixe) {
                return `scanandgo_${suffixe}_${this.appsociete}`;
            },

            setMode(isResto) {
                this.modeRestaurant = isResto;
                this.persistReglages();
            },

            chargerReglages() {
                // Réglages restaurant (indépendants de la liste des magasins)
                this.modeRestaurant = localStorage.getItem(this.storageKey("moderesto")) === "1";
                this.numeroTable = localStorage.getItem(this.storageKey("table")) || "";
                const list = this.returnGetAllmagasin;
                if (!list.length) return;
                const savedPid = localStorage.getItem(this.storageKey("magpid"));
                const found = savedPid
                    ? list.find(m => String(m.pid) === String(savedPid))
                    : null;
                this.selectedMagasin = found || list[0];
            },

            persistReglages() {
                if (this.selectedMagasin) {
                    localStorage.setItem(this.storageKey("magpid"), this.selectedMagasin.pid);
                }
                localStorage.setItem(this.storageKey("moderesto"), this.modeRestaurant ? "1" : "0");
                localStorage.setItem(this.storageKey("table"), this.numeroTable || "");
            },

            loadImage(src) {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = reject;
                    img.src = src;
                });
            },

            roundRect(ctx, x, y, w, h, r) {
                ctx.beginPath();
                ctx.moveTo(x + r, y);
                ctx.arcTo(x + w, y, x + w, y + h, r);
                ctx.arcTo(x + w, y + h, x, y + h, r);
                ctx.arcTo(x, y + h, x, y, r);
                ctx.arcTo(x, y, x + w, y, r);
                ctx.closePath();
            },

            // Génère un canvas QR avec le logo HSIGCOM au centre (correction 'H')
            async generateQrCanvas(sizePx) {
                const c = document.createElement("canvas");
                await QRCode.toCanvas(c, this.qrValue, {
                    errorCorrectionLevel: "H",
                    margin: 1,
                    width: sizePx,
                    color: { dark: this.qrColor, light: "#ffffff" },
                });
                try {
                    const logo = await this.loadImage(this.logoSrc);
                    const ctx = c.getContext("2d");
                    const aspect = (logo.width || 1) / (logo.height || 1);   // ~4.33 (logo large)
                    const lw = sizePx * 0.34;                                // largeur du logo ~34%
                    const lh = lw / aspect;
                    const padX = lw * 0.10;
                    const padY = lh * 0.40;
                    const pillW = lw + padX * 2;
                    const pillH = lh + padY * 2;
                    const pillX = (sizePx - pillW) / 2;
                    const pillY = (sizePx - pillH) / 2;
                    ctx.fillStyle = "#ffffff";
                    this.roundRect(ctx, pillX, pillY, pillW, pillH, pillH * 0.35);
                    ctx.fill();
                    ctx.drawImage(logo, (sizePx - lw) / 2, (sizePx - lh) / 2, lw, lh);
                } catch (e) {
                    console.warn("Logo QR non chargé:", e);
                }
                return c;
            },

            async buildQr() {
                try {
                    const c = await this.generateQrCanvas(600);
                    this.qrCodeDataUrl = c.toDataURL("image/png");
                } catch (e) {
                    console.error("Erreur QR:", e);
                    this.qrCodeDataUrl = "";
                }
            },

            async buildPoster() {
                try {
                    // Choix du visuel selon le mode ; fallback sur l'affiche supermarché
                    // tant que l'affiche restaurant définitive n'est pas fournie.
                    const src = this.modeRestaurant ? this.posterSrcRestaurant : this.posterSrc;
                    let poster;
                    try {
                        poster = await this.loadImage(src);
                    } catch (e) {
                        if (this.modeRestaurant) {
                            console.warn("Affiche restaurant introuvable, fallback sur l'affiche supermarché:", src);
                            poster = await this.loadImage(this.posterSrc);
                        } else {
                            throw e;
                        }
                    }
                    const canvas = document.createElement("canvas");
                    canvas.width = poster.naturalWidth || poster.width;
                    canvas.height = poster.naturalHeight || poster.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(poster, 0, 0);

                    const W = canvas.width;
                    const H = canvas.height;
                    // Config de placement du QR selon le mode (positions différentes par affiche)
                    const cfg = this.modeRestaurant ? this.posterResto : this.poster;
                    const cardW = W * cfg.size;
                    const cardX = W * cfg.cx - cardW / 2;
                    const cardY = H * cfg.cy - cardW / 2;

                    // carte blanche (quiet zone)
                    ctx.fillStyle = "#ffffff";
                    this.roundRect(ctx, cardX, cardY, cardW, cardW, cfg.radius);
                    ctx.fill();

                    // QR à l'intérieur
                    const pad = cardW * cfg.pad;
                    const qrSize = Math.round(cardW - pad * 2);
                    const qrCanvas = await this.generateQrCanvas(qrSize);
                    ctx.drawImage(qrCanvas, cardX + pad, cardY + pad, qrSize, qrSize);

                    await this.drawFooter(ctx, W, H);

                    // Badge « TABLE N » sur l'affiche restaurant (uniquement si une table est saisie)
                    if (this.modeRestaurant && this.numeroTable) {
                        this.drawTableNumber(ctx, W, H);
                    }

                    this.posterDataUrl = canvas.toDataURL("image/png");
                } catch (e) {
                    console.error("Erreur affiche:", e);
                    this.posterDataUrl = "";
                }
            },

            whatsappSvgDataUri() {
                const svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>" +
                    "<circle cx='16' cy='16' r='16' fill='#25D366'/>" +
                    "<path fill='#ffffff' d='M23.6 8.3A10.5 10.5 0 0 0 6.3 20.9L5 26l5.2-1.4a10.5 10.5 0 0 0 5 1.3h.01A10.5 10.5 0 0 0 23.6 8.3zM16.2 24.1h-.01a8.7 8.7 0 0 1-4.4-1.2l-.32-.19-3.28.86.88-3.2-.21-.33a8.7 8.7 0 1 1 7.34 4.06zm4.78-6.52c-.26-.13-1.55-.76-1.79-.85-.24-.09-.41-.13-.59.13-.17.26-.67.85-.83 1.03-.15.17-.31.2-.57.07-.26-.13-1.11-.41-2.11-1.3-.78-.7-1.31-1.56-1.46-1.82-.15-.26-.02-.4.11-.53.12-.12.26-.31.39-.46.13-.15.17-.26.26-.44.09-.17.04-.33-.02-.46-.07-.13-.59-1.42-.81-1.94-.21-.51-.43-.44-.59-.45l-.5-.01c-.17 0-.46.06-.7.33-.24.26-.92.9-.92 2.19s.94 2.54 1.07 2.71c.13.17 1.85 2.82 4.48 3.96.63.27 1.11.43 1.49.55.63.2 1.2.17 1.65.1.5-.07 1.55-.63 1.77-1.25.22-.61.22-1.14.15-1.25-.06-.11-.24-.18-.5-.31z'/></svg>";
                return "data:image/svg+xml;base64," + window.btoa(svg);
            },

            async drawFooter(ctx, W, H) {
                // Bande verte pleine largeur qui recouvre TOUT le pied de l'affiche
                const bandTopY = H * 0.916;
                const bandX = 0;
                const bandW = W;
                const bandH = H - bandTopY;

                ctx.fillStyle = "#0F6E56";
                ctx.fillRect(bandX, bandTopY, bandW, bandH);

                const cy = bandTopY + bandH / 2;
                const pad = W * 0.035;
                const avail = bandW - pad * 2;
                ctx.textBaseline = "middle";

                const nom = this.nomMagasin || this.societeName || "";
                const propText = "Proposition de HSIGCOM";
                const contactText = this.contact;
                let leftText = (nom ? nom + "   •   " : "") + "IFU : " + (this.ifu || "-");

                const measure = (size) => {
                    const icon = size * 1.6;
                    ctx.font = size + "px Arial, sans-serif";
                    const lw = ctx.measureText(leftText).width;
                    ctx.font = "bold " + size + "px Arial, sans-serif";
                    const pw = ctx.measureText(propText).width;
                    ctx.font = size + "px Arial, sans-serif";
                    const cw = ctx.measureText(contactText).width;
                    const gap = size * 0.5;
                    return { lw, pw, cw, gap, icon, rw: pw + gap + icon + gap * 0.6 + cw };
                };

                // Auto-ajuste la police pour tenir sur une ligne
                let fs = Math.round(bandH * 0.26);
                const minFs = 20;
                let m = measure(fs);
                while (m.lw + m.rw > avail && fs > minFs) { fs -= 1; m = measure(fs); }
                // Dernier recours : tronque le nom
                if (m.lw + m.rw > avail && nom) {
                    let n = nom;
                    while (n.length > 3 && m.lw + m.rw > avail) {
                        n = n.slice(0, -1);
                        leftText = n + "…   •   IFU : " + (this.ifu || "-");
                        m = measure(fs);
                    }
                }

                ctx.fillStyle = "#ffffff";
                ctx.textAlign = "left";
                ctx.font = fs + "px Arial, sans-serif";
                ctx.fillText(leftText, bandX + pad, cy);

                let waImg = null;
                try { waImg = await this.loadImage(this.whatsappSvgDataUri()); } catch (e) { /* ignore */ }
                let x = bandX + bandW - pad - m.rw;
                ctx.font = "bold " + fs + "px Arial, sans-serif";
                ctx.fillText(propText, x, cy);
                x += m.pw + m.gap;
                if (waImg) ctx.drawImage(waImg, x, cy - m.icon / 2, m.icon, m.icon);
                x += m.icon + m.gap * 0.6;
                ctx.font = fs + "px Arial, sans-serif";
                ctx.fillText(contactText, x, cy);
            },

            // Dessine un badge « TABLE N » sur l'affiche restaurant
            drawTableNumber(ctx, W, H) {
                const label = "TABLE " + this.numeroTable;
                const cx = W * this.posterTable.cx;
                const cy = H * this.posterTable.cy;
                const fs = Math.round(H * this.posterTable.fs);

                ctx.font = "bold " + fs + "px Arial, sans-serif";
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                const tw = ctx.measureText(label).width;
                const padX = fs * 0.55;
                const padY = fs * 0.35;
                const boxW = tw + padX * 2;
                const boxH = fs + padY * 2;

                // Badge arrondi
                ctx.fillStyle = "#0F6E56";
                this.roundRect(ctx, cx - boxW / 2, cy - boxH / 2, boxW, boxH, boxH * 0.3);
                ctx.fill();

                ctx.fillStyle = "#ffffff";
                ctx.fillText(label, cx, cy);
            },

            async rebuildAll() {
                // Dessine avec la valeur courante (qrValue = shortUrl si généré, sinon
                // URL longue). Le raccourcissement n'est PAS automatique : il est
                // déclenché par le bouton genererLienCourt().
                await this.buildQr();
                await this.buildPoster();
            },

            /**
             * Bouton « Générer le lien court » : demande un code au backend et, si
             * obtenu, régénère le QR/affiche avec l'URL courte. Sinon on informe et
             * on garde l'URL longue (repli, QR dense mais valide).
             */
            async genererLienCourt() {
                if (!this.selectedMagasin) {
                    if (window.toastr) window.toastr.warning("Sélectionnez d'abord un magasin.", "<b></b>");
                    return;
                }
                this.courtEnCours = true;
                try {
                    await this.demanderLienCourt();
                    if (this.shortUrl) {
                        await this.rebuildAll();
                        if (window.toastr) window.toastr.success("Lien court généré. Le QR est prêt.", "<b></b>");
                    } else {
                        if (window.toastr) window.toastr.error("Lien court indisponible. Le QR utilise l'URL longue.", "<b></b>");
                    }
                } finally {
                    this.courtEnCours = false;
                }
            },

            _headersCourt() {
                return {
                    'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JwtService.getToken(),
                    'csrftoken': this.$store.state.appsociete,
                };
            },

            /**
             * Demande au backend un lien court pour la cible courante (panier/menu).
             * Best-effort et non bloquant : toute erreur laisse shortUrl vide (repli
             * sur l'URL longue). Route PROTÉGÉE - la page admin est authentifiée.
             */
            async demanderLienCourt() {
                this.shortUrl = "";
                // Sans magasin sélectionné, la cible n'a pas de sens : on garde le repli.
                if (!this.selectedMagasin) return;
                try {
                    const url = process.env.VUE_APP_API_URL
                        + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/shortlink/'
                        + randomString();
                    const res = await axios.post(url, {
                        type: this.modeRestaurant ? "menu" : "panier",
                        cible: this.ciblePath,
                        scope: this.scopeCourt,
                    }, { headers: this._headersCourt(), withCredentials: true });

                    const d = res.data || {};
                    if (d.success && d.m && d.m.code) {
                        let base = process.env.VUE_APP_URL || "";
                        if (base && !base.endsWith("/")) base += "/";
                        this.shortUrl = `${base}s/${d.m.code}`;
                    }
                } catch (e) {
                    console.warn("[scanandgo] lien court indisponible, repli URL longue:", e);
                }
            },

            supportSuffix() {
                if (this.modeRestaurant) {
                    return "menu" + (this.numeroTable ? "-table-" + this.numeroTable : "-mural");
                }
                return "scan-and-go";
            },

            telechargerQr() {
                this.downloadDataUrl(this.qrCodeDataUrl, `qr-${this.supportSuffix()}-${this.safeName()}.png`);
            },

            telechargerAffiche() {
                this.downloadDataUrl(this.posterDataUrl, `affiche-${this.supportSuffix()}-${this.safeName()}.png`);
            },

            safeName() {
                return (this.appsociete || "magasin").replace(/[^a-z0-9\-_]/gi, "_");
            },

            downloadDataUrl(dataUrl, filename) {
                if (!dataUrl) return;
                const a = document.createElement("a");
                a.href = dataUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },

            imprimerAffiche() {
                if (!this.posterDataUrl) return;
                const w = window.open("", "_blank", "width=800,height=1100");
                if (!w) return;
                w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8">
<title>Affiche Scan &amp; Go</title>
<style>
  @page { size: A4 portrait; margin: 0; }
  html, body { margin: 0; padding: 0; }
  img { width: 100%; height: auto; display: block; }
</style></head><body>
  <img src="${this.posterDataUrl}" alt="Affiche Scan & Go">
</body></html>`);
                w.document.close();
                w.focus();
                setTimeout(() => { w.print(); }, 400);
            },
        },
        mounted() {
            // keyauthorisation : récupérée dans le store (authscango) si présente et non vide,
            // sinon aléatoire pour éviter un segment vide dans l'URL
            const authscango = this.$store.state.authscango;
             this.keyauthorisation = (authscango && authscango !== "") ? authscango : randomString();
            this.rand1 = randomString();
           // this.rand2 = randomString();
            this.chargerReglages();
            this.rebuildAll();
        },
    }
</script>

<style scoped>
    /* En-tête de carte (titre + actions) */
    .sg-card-head { display:flex; align-items:center; justify-content:space-between;
      gap:0.6rem; flex-wrap:wrap; margin-bottom:0.8rem; }
    .sg-card-head .cf-card__title { margin:0; }

    .sg-muted { color:var(--cf-muted); }

    /* Bloc code (URL encodée) */
    .sg-code { padding:0.5rem; border-radius:var(--cf-radius-xs);
      background:var(--cf-surface-alt); color:var(--cf-ink);
      border:1px solid var(--cf-border); font-family:monospace; }

    /* Champs charte (cf. fa2-*) */
    .fa2-label { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em;
      font-weight:600; color:var(--cf-muted); display:flex; align-items:center; gap:4px;
      margin-bottom:4px; }
    .fa2-req { color:rgb(var(--danger)); }
    .fa2-inp { width:100%; height:40px; padding:0 12px; border-radius:0.25rem;
      border:1px solid rgb(var(--input-border,203 213 225)); background:#fff;
      color:var(--cf-ink); font-size:0.82rem; outline:none;
      transition:border-color .2s, box-shadow .2s; }
    .fa2-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }

    /* Select : chevron maison (appearance:none) */
    .fa2-select { appearance:none; padding-right:28px; cursor:pointer; }
    .fa2-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%);
      color:var(--cf-faint); pointer-events:none; }
</style>
